export * from './src/automations-triggercatalog-v1-trigger-trigger-catalog.meta.js';
